<!-- Add manage configuration guard best in the state, or a block with a message here, to be further discussed -->
<ul id="configuration-fields" class="max-w-900px">
  <li class="configuration-field">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5">
          <h3>{{ "language" | localize }}</h3>
          <div class="description">
            <p>{{ "define_account_company_language" | localize }}</p>
          </div>
        </div>
        <div class="col-md-6 col-md-offset-1">
          <select class="gh-input-select" [(ngModel)]="currentLanguage">
            <option *ngFor="let lang of supportedLanguages" [ngValue]="lang.backend_label">{{ lang.label }}</option>
          </select>
          <div class="gh-fa" *ngIf="account.language !== currentLanguage">
            <div class="gh-b gh-accent" (click)="setLanguage(currentLanguage)">{{ "save" | localize }}</div>
          </div>
        </div>
      </div>
    </div>
  </li>
</ul>
